import './RememberMe.css';

interface RememberMeProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const RememberMe = ({ checked, onChange }: RememberMeProps) => {
  return (
    <div className="rememberMeContainer">
      <div className="remember">
        <input
          type="checkbox"
          checked={checked}
          name="lsRememberMe"
          id="checkbox"
          onChange={(event) => onChange(event.target.checked)}
        />
        <label htmlFor="checkbox" />
      </div>
      <label style={{ fontSize: '16px' }}>Remember me</label>
    </div>
  );
};

export default RememberMe;
